// extracted by mini-css-extract-plugin
export default {"advertCard":"c-a_gX","advertCardNum":"c-a_gY"};